import React, { useEffect, useState } from "react";
import { getNode } from "../../../../utils/overlaysUtils";

export const SearchBar = ({updateAddress, addressInfos}) => {
    const [searchInput, setSearchInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSuggestionsHidden, setIsSuggestionsHidden] = useState(true);
    const [placeholder, setPlaceholder] = useState('Rechercher une adresse');
    const displaySuggestion = (suggestion) => `${suggestion.properties.label} ${suggestion.properties.type === 'municipality' ? `(${suggestion.properties.context})`: ''}`

    useEffect(() => {
        setPlaceholder(getNode(addressInfos, ['address', 'label']) ? addressInfos.address.label : 'Rechercher une adresse');
    }, [addressInfos])

    useEffect(() => {
        const timeoutRef = setTimeout(() => {
            setLoading(true);
            fetch(`/api/suggestion?q=${encodeURIComponent(searchInput.toLowerCase())}&citycode=${addressInfos.com.com}`)
                .then(res => res.json())
                .then(json => {
                    setLoading(false);
                    setSuggestions(json.features.sort((a, b) => a.properties.score - b.properties.score));
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                    setSuggestions([]);
                });
        }, 300)
        return () => clearTimeout(timeoutRef);
    }, [searchInput]);

    const selectedSuggestion = (suggestion) => {
        setSearchInput("")
        setIsSuggestionsHidden(true);
        updateAddress(suggestion);
    }

    return (
        <div className="searchbar-container">
            <form name="address" onSubmit={(e) => e.preventDefault()}>
                <div className="input-container">
                    <label for="autocomplete-input" aria-label="Rechercher une adresse"></label>
                    <input
                        id="autocomplete-input"
                        type="text"
                        autoComplete="off"
                        aria-autocomplete="list"
                        name="address"
                        role="combobox"
                        placeholder={placeholder}
                        value={searchInput}
                        onFocus={() => setIsSuggestionsHidden(false)}
                        onChange={(e) => setSearchInput(e.target.value)}
                    />
                    {(searchInput || getNode(addressInfos, ['address', 'label'])) &&
                        <button className="reset"
                            type="button"
                            title="Effacer le contenu"
                            aria-owns="autocomplete-list"
                            onClick={() => searchInput ? setSearchInput("") : updateAddress(null)}>
                            &#215;
                        </button>
                    }
                </div>
                <ul className={isSuggestionsHidden ? '' : 'show'}
                    id="autocomplete-list"
                    role="listbox"
                    aria-label="Suggestions de saisie">
                    {suggestions.map((suggestion, index) => 
                        <li className="dropdown-item"
                            role="option"
                            tabIndex="-1"
                            aria-selected="false"
                            id={"autocomplete-item-" + index}
                            onClick={() => selectedSuggestion(suggestion)}>
                            <span>{displaySuggestion(suggestion)}</span>
                        </li>
                    )}
                </ul>
            </form>
        </div>
    )
}